import { grey } from "@mui/material/colors";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  active: string;
}

export const activeStyles = {
  bgcolor: grey[100],
  borderRadius: 1
}

export default function TabPanel(props: TabPanelProps) {
  const { children, active, index, ...rest } = props;

  return (
    <div
      role="tabpanel"
      hidden={active !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...rest}
    >
      {active === index && (children)}
    </div>
  );
}